<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.AddTaskLogs') }}</h4>
        </div>
        <section class="col-12 mx-auto align-self-md-center">
            <div class="half-design row">
                <div class="col-12 form-block">

                    <div class="col-12 col-md-6 col-lg-5 mx-auto pt-5">

                        <b-form @submit.prevent="onSubmit">

                            <div class="mb-3 text-left">
                                <label class="mb-1" :class="TaskState" for="Task">{{
                                    $t('title.Please_select_Task') }}</label>
                                <v-select id="type-select" v-model="formFields.Task" @change="validaterecipient"
                                    :class="TaskState" :options="TaskOptions" size="sm"></v-select>

                                <b-form-invalid-feedback :state="!formErrors.has('Task')">
                                    {{ formErrors.first('Task') }}
                                </b-form-invalid-feedback> <!-- Show error message -->
                            </div>

                            <div class="mb-3 text-left">
                                <!-- Task Name Field -->
                                <label for="taskName">{{ $t('title.Task_Name') }}</label>
                                <input type="text" v-model="formFields.taskName" readonly class="form-control" />
                            </div>

                            <div class="mb-3 text-left">
                                <label class="mb-1" :class="recipientState" for="recipient">{{
                                    $t('title.Please_select_recipient') }}</label>
                                <v-select id="type-select" v-model="formFields.recipient" @change="validaterecipient"
                                    :class="recipientState" :options="recipientOptions" size="sm"></v-select>

                                <b-form-invalid-feedback :state="!formErrors.has('recipient')">
                                    {{ formErrors.first('recipient') }}
                                </b-form-invalid-feedback> <!-- Show error message -->
                            </div>



                            <div class="mb-3 text-left">
                                <label for="status" class="mb-1" :class="statusState">
                                    {{ $t('title.SelectStatus') }}
                                </label>
                                <v-select id="status" v-model="formFields.status" @input="validateStatus"
                                    :class="statusState" :options="statusOptions" size="sm"></v-select>
                                <b-form-invalid-feedback :state="!formErrors.has('typeSelect')">
                                    {{ formErrors.first('typeSelect') }}
                                </b-form-invalid-feedback>
                            </div>



                            <b-button type="submit" variant="primary" class="mb-3 w-100" :disabled="loader">
                                <div class="spinner-border spinner-border-sm text-light" role="status" v-if="loader">
                                </div>
                                {{ $t('title.Submit') }}
                            </b-button>

                            <a class="text-center d-block mb-1" href="#" @click.prevent="onCancel">{{ $t('title.Cancel')
                            }}</a>

                            <b-form-invalid-feedback v-if="formErrors.general">{{ formErrors.general
                            }}</b-form-invalid-feedback>

                        </b-form>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reactive } from 'vue';
import { request } from "@/Util/Request";
import Error from "@/Util/Error";



export default {
    data() {
        return {
            formFields: reactive({
                recipient: { value: '', label: this.$t('title.Please_select_recipient') },
                Task: { value: '', label: this.$t('title.Please_select_Task') },
                status: { value: '1', label: this.$t('title.Active') },
                taskName: '',

            }),
            statusOptions: [
                { label: this.$t('title.Active'), value: '1' },
                { label: this.$t('title.Inactive'), value: '0' },
            ],
            formErrors: new Error({}),
            recipientOptions: [],
            TaskOptions: [],

        };
    },

    computed: {
        ...mapGetters(['loader']),
        statusState() {
            return this.formFields.status === null ? '' : this.formErrors.status ? 'is-invalid' : 'is-valid'; // Add computed for status
        },
        recipientState() {
            return this.formFields.recipient === '' ? '' : this.formErrors.$errors.recipient ? 'is-invalid' : 'is-valid';
        },
        TaskState() {
            return this.formFields.recipient === '' ? '' : this.formErrors.$errors.recipient ? 'is-invalid' : 'is-valid';
        },
    },

    methods: {
        async fetchrecipient() {
            try {
                const response = await request({
                    method: 'get',
                    url: `/admin/system-users`,

                });
                const data = response.data;
                this.recipientOptions = [
                    { value: '', label: this.$t('title.Please_select_recipient') }, // Default option
                    ...data.map(recipient => ({
                        value: recipient.id,
                        label: recipient.full_name,
                    }))
                ];
            } catch (error) {
                console.error('Error fetching recipient:', error);
            }
        },
        async fatchtask() {
            try {
                const response = await request({
                    method: 'get',
                    url: `/admin/scheduled-task`,
                });
                const data = response.data;

                this.TaskOptions = [
                    { value: '', label: this.$t('title.Please_select_Task') }, // Default option
                    ...data.map(task => ({
                        value: task.id,
                        label: task.description,
                        hiddenValue: task.name,
                    }))
                ];
            } catch (error) {
                console.error('Error fetching tasks:', error);
            }
        },


        validateStatus() {
            const status = this.formFields.status;
            if (!status) {
            } else {
                delete this.formErrors.$errors.status;
            }
        },

        validaterecipient() {
            const typeSelect = this.formFields.typeSelect;

            if (!typeSelect.value) {
                this.formErrors.$errors.typeSelect = [this.$t('title.serviceRequired')];
            } else {
                delete this.formErrors.$errors.typeSelect;
            }
        },

        reloadPage() {
            this.$router.push({ name: 'TaskLogs' });
        },

        async onSubmit() {
            const payload = {

                is_active: this.formFields.status.value ?? '0',
                task_id: this.formFields.Task.value,
                task_name: this.formFields.Task.hiddenValue,
                recipient: this.formFields.recipient.value,
            };

            try {
                const response = await request({
                    method: 'post',
                    url: 'admin/Task-Logs',
                    data: payload,
                    headers: {
                        'Content-Type': 'application/json',   // Content type for JSON data
                    }
                });

                const data = response;
                if (response['message'] && response['message'].includes("success") || response['code'] == 200) {
                    this.showToast();
                    setTimeout(() => {
                        this.reloadPage();
                    }, 1500);
                } else {
                    throw new Error(data.message || 'Error submitting form');
                }
            } catch (error) {
                this.formErrors = new Error({});

                // if (error?.data?.errors) {
                //     const errors = error.data.errors;
                //     this.formErrors.$errors.name = errors.name ? errors.name : '';
                //     this.formErrors.$errors.typeSelect = errors.scheduled_type ? errors.scheduled_type : '';
                //     this.formErrors.$errors.start_time = errors.start_time ? errors.start_time : '';
                //     this.formErrors.$errors.status = errors.is_active ? errors.is_active : '';
                //     this.formErrors.$errors.general = "Please fix the errors and try again.";
                //     return false;

                // } else {

                //     this.formErrors.general = "Something went wrong. Please try again.";
                // }
            }

        },

        showToast() {
            const h = this.$createElement;
            const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
                this.$t('title.dataSaved')
            ]);
            // Create the title
            const vNodesTitle = h(
                'div',
                { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
                [h('strong', { class: 'mr-2' }, this.$t('title.dataSavedTitle'))]
            );
            // Pass the VNodes as an array for message and title
            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: 'success',
            });
        },

        onCancel() {
            this.$router.push({ name: 'TaskLogs' });
        },

    },

    watch: {
        'formFields.Task.value': function (newTaskId) {
            if (newTaskId) {
                const selectedTask = this.TaskOptions.find(task => task.value === newTaskId);
                if (selectedTask) {
                    this.formFields.taskName = selectedTask.hiddenValue;
                }
            } else {
                this.formFields.taskName = '';
            }
        }
    },


    components: {

    },
    created() {
        this.fetchrecipient();
        this.fatchtask();
    },
};
</script>
